import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";

import { FunctionComponent, useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

import { classNames } from "@/utils/classNames";

import { Icon } from "../Icon/Icon";

export const Information: FunctionComponent<{
	information: string | JSX.Element;
	className?: string;
	iconClassName?: string;
}> = ({ information, className, iconClassName }) => {
	const [showInformation, setShowInformation] = useState(false);
	const selectFieldRef = useRef<HTMLDivElement>(null);

	const dropdownRef = useRef<HTMLDivElement>(null);
	const [dropdownStyle, setDropdownStyle] = useState<React.CSSProperties>({});

	const updateDropdownPosition = useCallback(() => {
		if (selectFieldRef.current) {
			const rect = selectFieldRef.current.getBoundingClientRect();
			const dropdownRec = dropdownRef.current?.getBoundingClientRect();
			const dropdownPositionStyle: React.CSSProperties = {
				position: "absolute",
			};

			// Dynamically set dropdown position based on `position` prop
			dropdownPositionStyle.top = rect.bottom + window.scrollY - ((dropdownRec?.height ?? 0) + 20);
			dropdownPositionStyle.left = rect.left + window.scrollX;

			setDropdownStyle(dropdownPositionStyle);
		}
	}, []);

	useEffect(() => {
		if (showInformation) {
			updateDropdownPosition();
			window.addEventListener("resize", updateDropdownPosition);
		} else {
			window.removeEventListener("resize", updateDropdownPosition);
		}

		return () => {
			window.removeEventListener("resize", updateDropdownPosition);
		};
	}, [showInformation, updateDropdownPosition]);

	return (
		<span className="group cursor-pointer inline-flex relative z-1000 -top-0.5">
			<div ref={selectFieldRef} className="flex flex-row items-center text-text-meta">
				<Icon
					className={classNames(
						iconClassName || "text-text-disabled w-3 h-3 group-hover:text-brand-light"
					)}
					icon={faInfoCircle}
					onMouseEnter={() => setShowInformation(true)}
					onMouseLeave={() => setShowInformation(false)}
				/>
				{showInformation &&
					createPortal(
						<p
							ref={dropdownRef}
							className={classNames(
								"absolute transform -translate-x-1/2 w-[200px] bg-white shadow-all p-3 rounded-md text-xs z-[10000] group-hover:block"
							)}
							style={dropdownStyle}
						>
							{information}
						</p>,
						document.body
					)}
			</div>
		</span>
	);
};
